import { useMutation, useQueryClient } from '@tanstack/react-query';

import { pnrDiscoveryQueryKeys } from '~/hooks/apis/flights/usePnrDiscoveries';

import { cancelPnrImportOrder } from '~/services/OrdersService';

export function useCancelPnrImportOrder() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: cancelPnrImportOrder,
    onSettled: () => queryClient.invalidateQueries({ queryKey: pnrDiscoveryQueryKeys.all }),
  });
}
